import { initializeFaro as coreInit } from '@grafana/faro-core';
import { makeCoreConfig } from './config';
export function initializeFaro(config) {
    const coreConfig = makeCoreConfig(config);
    if (!coreConfig) {
        return undefined;
    }
    return coreInit(coreConfig);
}
//# sourceMappingURL=initialize.js.map